import React from 'react';
import ShadowBox from '../ShadowBox/ShadowBox';
import SectionHeader from '../SectionHeader/SectionHeader';

const AppGroupGrid = ({children}) => (
  <div style={{ display:'block'}}>
    {React.Children.map (children, (child, i) => {
     const typeWidth = (type) =>({
        'Material': '100%',
        'Costing': '100%',

        })[type];

      return (
       <div className={child.props.type} style={{ display:'inline-block', width:typeWidth(child.props.type)}}>
        {child.props.type === 'Material' && (
        <div style={{width: '65%', padding: '30px', minHeight: '230px'}}>
          <ShadowBox>
            <SectionHeader title={child.props.type} />
            {child}
          </ShadowBox>
        </div>
        )}
         {child.props.type !== 'Material' && (
                  <div  style={{width: '30%', padding: '30px', minHeight: '230px', display:'inline-block'}}>
                      <ShadowBox>
                          <SectionHeader title={child.props.type} />
                          {child}
                      </ShadowBox>
                  </div>
              )}
        </div>
      );
    })}
  </div>
);

export default AppGroupGrid;
